import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ISelectOption } from '@widgets/multi-select';
import { ERR_BAD_REQUEST } from '@app/contstants/http-codes';
import { ServerError } from '@app/error/ServerError';

export const fetch = async ({
  managers,
  assignmentKind,
  assignmentOverridePercent,
  comment,
  source,
  tag,
  clientId,
  terms,
  overrideName,
  outOfFlex,
  isNew,
  assignmentValidFrom,
}: {
  clientId: number;
  managers?: ISelectOption[] | null;
  assignmentKind?: 'resignation_transfer' | 'reassignment_transfer' | null;
  assignmentOverridePercent?: string | null;
  comment?: string | null;
  source?: ISelectOption | null;
  tag?: ISelectOption | null;
  terms?: number | null;
  overrideName?: string | null;
  outOfFlex?: boolean | null;
  isNew?: boolean | null;
  assignmentValidFrom?: string | null;
}): Promise<void> => {
  try {
    const data: {
      managers?: string[] | null;
      assignment_kind?: 'resignation_transfer' | 'reassignment_transfer' | null;
      assignment_override_percent?: string | null;
      comment?: string | null;
      tags?: string | null;
      source?: string | null;
      terms?: number | null;
      override_name?: string | null;
      out_of_flex?: boolean | null;
      is_new?: boolean | null;
      assignment_valid_from?: string | null;
    } = {};

    if (managers !== undefined) {
      data['managers'] = managers ? managers.map(manager => manager.value) : null;
    }

    if (assignmentKind !== undefined) {
      data['assignment_kind'] = assignmentKind;
    }

    if (assignmentOverridePercent !== undefined) {
      data['assignment_override_percent'] = assignmentOverridePercent;
    }

    if (comment !== undefined) {
      data['comment'] = comment;
    }

    if (tag !== undefined) {
      data['tags'] = tag?.value;
    }

    if (terms !== undefined) {
      data['terms'] = terms;
    }

    if (overrideName !== undefined) {
      data['override_name'] = overrideName;
    }

    if (source !== undefined) {
      data['source'] = source?.value;
    }

    if (outOfFlex !== undefined) {
      data['out_of_flex'] = outOfFlex;
    }

    if (isNew !== undefined) {
      data['is_new'] = isNew;
    }

    if (assignmentValidFrom !== undefined) {
      data['assignment_valid_from'] = assignmentValidFrom;
    }

    await api.patch<{ id: string; name: string }>(
      `${PANEl_BASE_URL}/clients/clients/${clientId}/update_client/`,
      data
    );
  } catch (e: any) {
    if (e.status === ERR_BAD_REQUEST) {
      throw new ServerError(e.response?.data?.error ?? e.response?.data);
    }
  }
};

export const useUpdateCustomer = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
